<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">企画相談結果入力</h1>
    <span class="close" (click)="close()"></span>
  </div>

  <div class="dialog__body">
    <p class="dialog__description">企画相談の結果を選択してください。</p>

    <ag-job-az-check-consulting-info
      [consultingInfo]="consultingInfo"
      [showDescription]="true"
      [editableDescription]="true"
      (resultDescriptionChange)="resultDescription = $event"
    ></ag-job-az-check-consulting-info>
  </div>

  <div class="dialog__footer">
    <button class="dialog__button dialog__button--gray" (click)="close()">
      キャンセル
    </button>
    <button class="dialog__button dialog__button--red" (click)="save(false)">
      ミドル許容しない
    </button>
    <button class="dialog__button dialog__button--green" (click)="save(true)">
      ミドル許容する
    </button>
  </div>
</div>
